// extracted by mini-css-extract-plugin
export var quantityInput = "_en-0";